import React, { Component } from 'react';
import { Button } from '@components/shared/Button';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from "axios";
import { Spinner } from '@components/shared/Spinner';
import { FilterPagination } from '@components/adm/shared/FilterPagination';

export class FilterFiles extends Component {
    static displayName = FilterFiles.name;

    constructor(props) {
        super(props);

        this.state = {
            downloading: false,
            errDownloading: false,

            downloadFailList: []
        };

        this.paginationOptions = [
            { text: '1', value: 1},
            { text: '10', value: 10},
            { text: '25', value: 25},
            { text: '50', value: 50},
            { text: '100', value: 100},
            { text: 'Vše', value: 'all' },
        ];

        this.loginHeader = {
            headers: {
                'Header-Authority': JSON.stringify({ Token: this.props.loggedAdmin.loginToken })
            }
        };
    }

    FileGetFullName = (file) => {
        return `${file.name}${file.extension}`;
    }

    DownloadServerFilesZip = async (fileList) => {

        this.setState((prevState) => ({ ...prevState, downloading: true, errDownloading: false, downloadFailList: [] }));
        let namesWithExtension = fileList.map(f => this.FileGetFullName(f));

        return axios
            .post(`/api/adm/file/${this.props.type}/downloadBatch`, namesWithExtension, this.loginHeader)
            .then((response) => {
                let data = response.data;
                console.log(data)

                if (data.responseCode !== 200)
                    return;

                let failList = data.failList.map(f => f.name);
                this.setState((prevState) => ({ ...prevState, downloadFailList: failList }));

                if (data.successList.length <= 0)
                    return;
              
                const zip = new JSZip();
                const folder = zip.folder(`${this.props.type}s`);
                
                for (const fileObj of Object.entries(data.data)) {
                    const [fileName, fileBytes] = fileObj;

                    const byteCharacters = atob(fileBytes); // Decode base64 string
                    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'text/plain' });

                    folder.file(fileName, blob);
                }

                zip.generateAsync({ type: "blob" })
                    .then((blob) => {
                        saveAs(blob, `${this.props.type}s.zip`);
                    })
                    .catch((err) => {
                        console.error("Error generating zip file", err);
                    });   

            }).catch(() => {
                this.setState((prevState) => ({ ...prevState, errDownloading: true }));
            }).finally(() => {
                this.setState((prevState) => ({ ...prevState, downloading: false }));
            });
    }

    DownloadPublicFilesZip = async (fileList) => {

        const zip = new JSZip();
        const folder = zip.folder(`${this.props.type}s`); // Create a folder inside the zip

        // Loop through all the files to add them to the zip
        for (const file of fileList) {
            const fullName = `${file.name}${file.extension}`;
            const fullPath = `/files/${this.props.type}s/${fullName}`;

            try {
                // Fetch the file as a blob
                const response = await fetch(fullPath);
                const blob = await response.blob();

                // Add the file to the zip folder
                folder.file(fullName, blob);
            } catch (error) {
                console.error(`Error fetching file: ${fullName}`, error);
            }
        }

        // Generate the zip and trigger the download
        zip.generateAsync({ type: "blob" })
            .then((blob) => {
                //console.log(blob)
                saveAs(blob, `${this.props.type}s.zip`);
            })
            .catch((err) => {
                console.error("Error generating zip file", err);
            });
    }

    DownloadFilteredFiles = async () => {

        if (this.props.type === 'log')
            return this.DownloadServerFilesZip(this.props.fileList)

        this.DownloadPublicFilesZip(this.props.fileList);
    };

    HandleDeleteFilters = () => {

        if (JSON.stringify(this.props.defaultFilters) == JSON.stringify(this.props.filters))
            return;

        this.props.HandleSetFilters(this.props.defaultFilters);
    }

    HandleSetFilterName = (val) => {
        let newFilters = { ...this.props.filters, name: val, paginationPage: 1 }
        this.props.HandleSetFilters(newFilters);
    }

    HandleSetFilterExtension = (val) => {
        let newFilters = { ...this.props.filters, extension: val, paginationPage: 1 }
        this.props.HandleSetFilters(newFilters);
    }

    HandleSetFilterPaginationCount = (val) => {
        let newFilters = { ...this.props.filters, paginationCount: val, paginationPage: 1 }
        this.props.HandleSetFilters(newFilters);
    }

    HandleSetFilterPaginationPage = (val) => {
        let newFilters = { ...this.props.filters, paginationPage: val }
        this.props.HandleSetFilters(newFilters);
    }

    RenderDownloadBatchButton = () => {

        let buttonContent = <div className='d-flex align-items-center'>
            {this.state.downloading &&
                <div className='me-2'>
                    <Spinner tiny />
                </div>
            }
            Stáhnout vyfiltrované
        </div>;

        return <div className='d-flex flex-column'>
            {this.state.errDownloading &&
                'Stažení souborů bylo neúspěšné'
            }
            <Button text={buttonContent} OnClick={() => this.DownloadFilteredFiles()} />
        </div>
    }

    render() {
        return (
            <div className='d-flex flex-column'>
                {
                    this.state.downloadFailList.length > 0 &&
                    <div className='d-flex flex-column mb-2 border-bottom border-danger pb-2'>
                        <div className='redText'>Následující soubory nebylo možné stáhnout:</div>
                        {this.state.downloadFailList.map(f => <div key={f}>{f}</div>)}
                    </div>
                }
                <div className='border-bottom my-2 pb-2'>
                    <div className='d-flex flex-column flex-lg-row align-items-lg-end'>
                        <div className='d-flex flex-wrap align-items-end'>
                            <div className='mx-2 d-flex flex-column'>
                                <label htmlFor='state'>Záznamů na stránce</label>
                                <select id='state' className='p-1' value={this.props.filters.paginationCount} onChange={(e) => this.HandleSetFilterPaginationCount(e.target.value)}>
                                    {this.paginationOptions.map((o) => {
                                        return (
                                            <option className='p-1' value={o.value} key={o.value}>
                                                {o.text}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div className='mx-2 d-flex flex-column me-3'>
                                <label htmlFor='name'>Vyhledat název</label>
                                <input type='text' id='name' value={this.props.filters.name} onChange={(e) => this.HandleSetFilterName(e.target.value)} />
                            </div>
                            {this.props.extensionList.length > 1 &&
                                <div className='mx-2 d-flex flex-column'>
                                    <label htmlFor='extension'>Formát</label>
                                    <select id='extension' className='p-1' value={this.props.filters.extension} onChange={(e) => this.HandleSetFilterExtension(e.target.value)}>
                                        <option className='p-1' value={'all'}>
                                            Vše
                                        </option>
                                        {this.props.extensionList.map((e) => {
                                            return (
                                                <option className='p-1' value={e} key={e}>
                                                    {e}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            }
                        </div>
                        <div className='ps-1 mt-2 mt-lg-0 d-flex align-items-end justify-content-between col'>
                            <div className='me-2'>
                                <Button text={'Smazat filtry'} small OnClick={() => this.HandleDeleteFilters()} />
                            </div>
                            {this.RenderDownloadBatchButton()}
                        </div>
                    </div>
                </div>
                <FilterPagination
                    paginationCount={this.props.filters.paginationCount}
                    listCount={this.props.fileListCount}
                    page={this.props.filters.paginationPage}
                    allRowsCount={this.props.allRowsCount}
                    OnPageNumberClick={this.HandleSetFilterPaginationPage}
                />
            </div>
        );
    }
}
